import styled from 'styled-components';
import media from 'styled-media-query';
import { MDBContainer } from 'mdbreact';

import colors from 'themes/Main';
import { Text } from 'components/DescriptionText/styles';
import { Divider as DefaultDivider } from 'components/FormGroup/Divider/styles';

const { gray03, gray05, danger } = colors;

export const Container = styled(MDBContainer)`
  margin: 0 auto;
  max-width: calc(100% - 224px) !important;

  ${media.lessThan('medium')`
    max-width: 100% !important;
  `}
`;

export const Introduction = styled.div`
  margin-top: 50px;
`;

export const FeaturedText = styled(Text)`
  text-transform: uppercase;

  span {
    display: inline-block;
    font-size: 18px;
    color: ${gray03};
    font-weight: 400;
    margin-left: 8px;
  }
`;

export const Divider = styled(DefaultDivider)`
  margin-top: 32px;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${gray05};
  }
`;

export const Form = styled.form``;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Buttons = styled.div`
  margin: 32px 0;

  button:nth-child(2) {
    margin-left: 16px;
  }
`;

export const RemoveSale = styled.button`
  cursor: pointer;
  border: none;
  background: transparent;
  width: auto;
  height: auto;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  outline: none;
  appearance: none;

  &:hover,
  &:active,
  &:focus {
    outline: none;
    border: none;
    appearance: none;
  }

  svg {
    cursor: pointer;
    opacity: ${props => {
      const { disabled } = props;
      return !disabled ? 1 : 0.5;
    }};
  }
  path {
    fill: ${danger};
  }
`;
